__turbopack_context__.v({
  "MuiDialog-container": "modal-module-scss-module__c2CVBW__MuiDialog-container",
  "MuiDialog-paper": "modal-module-scss-module__c2CVBW__MuiDialog-paper",
  "close": "modal-module-scss-module__c2CVBW__close",
  "modal": "modal-module-scss-module__c2CVBW__modal",
  "wrap": "modal-module-scss-module__c2CVBW__wrap",
});
